export type Transformation = {
  id: string
  label: string
  title: string
  location: string
  before: string
  after: string
}

export const transformations: Transformation[] = [
  {
    id: 'kitchen',
    label: 'Kitchen Remodel',
    title: 'Outdated kitchen to a warm, functional centerpiece',
    location: 'Louisville, KY',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/5c647395-2373-49da-99f5-556db985e7fd.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/340ab1f0-9280-4b90-b3d5-fe327372ccf0.jpg',
  },
  {
    id: 'bathroom',
    label: 'Bathroom Remodel',
    title: 'Dated bathroom to a clean, modern retreat',
    location: 'Lexington, KY',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/6b7354fe-15d2-4d6a-a91d-c04b6312d7fa.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/9f8e5d0e-fcf3-47a6-85d9-a46e02761b79.jpg',
  },
  {
    id: 'exterior',
    label: 'Exterior Painting',
    title: 'Dull, weathered siding to standout curb appeal',
    location: 'Bowling Green, KY',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/041f2cf7-cd88-472f-963f-ba86eca115e9.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/31827ce2-e22b-41a2-9549-7cc4abbd40db.jpg',
  },
  {
    id: 'interior',
    label: 'Interior Finishing',
    title: 'Worn interior to a professionally finished living space',
    location: 'Elizabethtown, KY',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/d04112b3-4c9d-4fc5-b868-9402c34e5891.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/3df59e42-a8a5-49f2-98c0-ebd3dcfb552b.jpg',
  },
]
